import { makeAutoObservable } from 'mobx'

class NewAssignDealerDrawerStore {
  isOpen: boolean = false
  isResetToCreateOpen: boolean = false
  isChangePaymentOpen: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setIsOpen = (value: boolean) => {
    this.isOpen = value
  }

  setIsResetToCreateOpen = (value: boolean) => {
    this.isResetToCreateOpen = value
  }

  setIsChangePaymentOpen = (value: boolean) => {
    this.isChangePaymentOpen = value
  }
}

export const newAssignDealerDrawerStore = new NewAssignDealerDrawerStore()
